import React from "react";
import PropTypes from "prop-types";
import { useRef, useEffect, useState } from 'react';

import {pushToGTMDataLayer} from '../../../utils/helpers';

export const Tooltip = ({ TooltipName, TooltipText, TooltipClasses, ...props }) => {
	const [toggle, setToggle] = useState(false);
	const [tooltipHeight, setTooltipHeight] = useState(null)
	const [isTop, setTop] = useState(null);
	const [isAnimating, setIsAnimating] = useState(false)
	const [didInit, setInit] = useState(false);
	const toolRef = useRef();

	const tooltipText = TooltipText;
	
	
	useEffect(() =>{
		const tooltip = toolRef.current;
		if(typeof window.gsap === 'object' && !didInit && !tooltipHeight && tooltip && toggle){
			const initHeight=tooltip.querySelector('.mz-tooltip__text').offsetHeight;
			setTooltipHeight(initHeight)
			setInit(true);
			toggleCollapse(tooltip, 0.3, initHeight);
        }else if(didInit){
            toggleCollapse(tooltip, 0.3);
        }
	}, [toggle]);

	function toggleCollapse(tooltip, time, initHeight=tooltipHeight){
		if(!isAnimating){
			const tooltipCont = tooltip.querySelector('.mz-tooltip__text');
			const tooltipWidth = 300;
			tooltipCont.style.left='';
			tooltipCont.style.top='';
			const tooltipLeft = tooltipCont.getBoundingClientRect().left;
			const tooltipBottom = tooltipCont.getBoundingClientRect().bottom;
			const tooltipRight = tooltipLeft + tooltipWidth;

			const pricingHeight =  document.querySelector('.mz-pricing') !== null ? document.querySelector('.mz-pricing').offsetHeight : 0;

			if(toggle){
				if(tooltipBottom + initHeight > (window.innerHeight - pricingHeight)){
					tooltip.classList.add('reverse');
					window.gsap.set(tooltipCont,{top:-10, transformOrigin:'bottom center'})
					window.gsap.fromTo(tooltipCont, time,{autoAlpha:0, height:0},{autoAlpha:1, height:initHeight, onUpdate: function(){
							if(parseInt(tooltipCont.style.top, 10) <= -(initHeight - 20)){
								tooltipCont.style.top = -(initHeight - 10)+ 'px'
							}else{
								tooltipCont.style.top = -(tooltipCont.offsetHeight + 10)+ 'px';
							}
						}
					})
					setTop(true);
				}else{
					tooltip.classList.remove('reverse');
					window.gsap.set(tooltipCont,{top:'6px', transformOrigin:'top center'})
					window.gsap.fromTo(tooltipCont, time,{autoAlpha:0, height:0},{autoAlpha:1,height:initHeight})
					setTop(false);
				}
			}else{
				setIsAnimating(true)
				if(isTop){
						window.gsap.to(tooltipCont, time,{autoAlpha:0, height:0, onComplete:enableAni, transformOrigin:'bottom center', onUpdate: function(){
							if(parseInt(tooltipCont.style.top, 10) >= -10){
								tooltipCont.style.top = '-10px'
							}else{
								tooltipCont.style.top = -(tooltipCont.offsetHeight + (tooltip.parentElement.offsetHeight *2)) + 'px';
							}
						}
					})
				}else{
					window.gsap.to(tooltipCont, time,{autoAlpha:0, height:0, onComplete:enableAni, transformOrigin:'top center'})
				}
				function enableAni(){
					setIsAnimating(false);
				}
			}
			if(tooltipRight > window.innerWidth){
				tooltipCont.style.left='auto';
				tooltipCont.style.right= '-20px';
			}else if(tooltipLeft < 0){
				tooltipCont.style.left='-20px';
				tooltipCont.style.right= 'auto';
			}
		}
	}
	const toolClick = (e)=>{
		if(!isAnimating){
			setToggle(!toggle);
		}
	}
	
	return (
		tooltipText !== undefined &&
			<div className={
				toggle
				? "mz-tooltip is-expanded"
				: "mz-tooltip"
			}
			{...props}
			ref={toolRef}
			onClick={(e) => {
				toolClick(e);
				pushToGTMDataLayer({'action':'Tooltip', 'Tooltip': TooltipName}, true, false);
			}}
			onMouseEnter={(e)=>{
				if(window.matchMedia("(min-width: 1025px)").matches){
					if(!isAnimating){
						setToggle(true);
					}
					pushToGTMDataLayer({'action':'Tooltip', 'Tooltip': TooltipName});
				}
			}}
			onMouseLeave={(e) =>{
				if(window.matchMedia("(min-width: 1025px)").matches){
					if(!isAnimating){
						setToggle(false);
					}
				}
			}}>
				<i className="mz-svg mz-svg--grey mz-svg-info"></i>
				<span className="mz-tooltip__text label label--tight" >
					<div>
						{tooltipText}
						<div onClick={() => setToggle(!toggle)} className="mz-tooltip__close">
						<i className="mz-svg mz-svg-x"></i>
						</div>
					</div>
				</span>
			</div>
	);
};

Tooltip.propTypes = {
	TooltipText: PropTypes.string,
	TooltipClasses: PropTypes.string,
};
